import React from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import TopView from './TopView/TopView';
import WhatView from './WhatView';
import HowView from './HowView';
import ThinkView from './ThinkView';
import WhereView from './WhereView';
import WhatDoView from './WhatDoView';
import BottomCta from './BottomCta';
import TwoBlogSec from '../Common/TwoBlogSec';
import FreQuestions from '../onlyfans-protection/freQuestions';
import { useIsMobile } from '@/hooks/useIsMobile';

interface CommonLayoutProps {
  data: any;
  topViewContent?: React.ReactNode;
  afterTopContent?: React.ReactNode;
  whatDoViewContent?: React.ReactNode;
}

/**
 * 通用页面布局组件
 * TopViewContent: TopView 中的搜索框内容
 * afterTopContent: TopView 后面的自定义内容（如 ImageSearchContainer）
 * whatDoViewContent: WhatDoView 中的自定义内容
 */
export default function CommonLayout({ data, topViewContent, afterTopContent, whatDoViewContent }: CommonLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <div>
      <CommonBackContent>
        {/* 头部区域 */}
        <TopView data={data} reverseSearchContent={topViewContent} />

        {/* TopView 后面的自定义内容 */}
        {afterTopContent}

        {/* what 区域 */}
        <WhatView data={data} />

        {/* how 区域 */}
        <HowView data={data} />

        {/* think 区域 */}
        <ThinkView data={data} />

        {/* where 区域 */}
        <WhereView data={data} />

        {/* what do 区域 */}
        <WhatDoView data={data} reverseSearchContent={whatDoViewContent} />

        <div style={{ padding: isMobile ? '0 5px' : '0' }}>
          {/* blog 区域 */}
          <div style={{ marginTop: '54px' }}>
            <TwoBlogSec
              blogList={data.blogList}
              topBlogList={data.topBlogList}
              blogTitle={data.contentInfo['section-blog']?.title}
              topBlogTitle={data.contentInfo['section-top-blog']?.title}
              textAlign="left"
            />
          </div>

          {/* faq 区域 */}
          {data.contentInfo['section-faq']?.title && (
            <div style={{ padding: isMobile ? '0 10px' : '0' }}>
              <FreQuestions data={data} textAlign="left" />
            </div>
          )}
        </div>
      </CommonBackContent>

      {/* 底部 cta 区域 */}
      <BottomCta data={data} />
    </div>
  );
}
